import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const calc = (end) => {
  const diff = new Date(end).getTime() - Date.now();
  if (isNaN(diff) || diff <= 0) return null;
  const s = Math.floor(diff / 1000);
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
};

const pad = (n) => String(n).padStart(2, "0");

export const PromoCountdown = ({ endsAt, testId }) => {
  const [t, setT] = useState(() => calc(endsAt));
  useEffect(() => {
    setT(calc(endsAt));
    const id = setInterval(() => setT(calc(endsAt)), 1000);
    return () => clearInterval(id);
  }, [endsAt]);

  if (!t) return null;
  return (
    <div data-testid={testId} className="mt-1 inline-flex items-center gap-1.5 rounded-full bg-su-danger/10 border-2 border-su-danger/30 px-3 py-1 text-su-danger font-heading font-black text-xs">
      <Clock className="w-3.5 h-3.5" />
      Diskon berakhir dalam {t.d > 0 && `${t.d}h `}{pad(t.h)}:{pad(t.m)}:{pad(t.s)}
    </div>
  );
};
